const NODE_FORM_MEMORY_STORAGE_KEY = 'nodal:lastNodeFormByScope:v1';

function normalizeScopePart(value) {
  return String(value || '').trim().toLowerCase();
}

function normalizeFormKey(value) {
  return String(value || '').trim();
}

/**
 * Scope key for remembered form selection: base + type.
 *
 * @param {{ baseKey?: string|null, typeKey?: string|null }} params
 * @returns {string}
 */
export function getNodeFormScopeMemoryKey({ baseKey, typeKey } = {}) {
  const base = normalizeScopePart(baseKey) || '__base__';
  const type = normalizeScopePart(typeKey) || '__type__';
  return `${base}::${type}`;
}

function readStoredFormMap() {
  if (typeof window === 'undefined' || !window?.localStorage) return {};

  try {
    const raw = window.localStorage.getItem(NODE_FORM_MEMORY_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeStoredFormMap(nextMap) {
  if (typeof window === 'undefined' || !window?.localStorage) return;

  try {
    window.localStorage.setItem(NODE_FORM_MEMORY_STORAGE_KEY, JSON.stringify(nextMap || {}));
  } catch {
    // Storage write failures should not block form rendering.
  }
}

/**
 * @param {string} scopeMemoryKey
 * @returns {string}
 */
export function getStoredFormKeyForScope(scopeMemoryKey) {
  if (!scopeMemoryKey) return '';
  const map = readStoredFormMap();
  return normalizeFormKey(map?.[scopeMemoryKey]);
}

/**
 * @param {string} scopeMemoryKey
 * @param {string} formKey
 */
export function setStoredFormKeyForScope(scopeMemoryKey, formKey) {
  if (!scopeMemoryKey) return;
  const normalizedFormKey = normalizeFormKey(formKey);
  if (!normalizedFormKey) return;

  const map = readStoredFormMap();
  if (map?.[scopeMemoryKey] === normalizedFormKey) return;

  writeStoredFormMap({
    ...map,
    [scopeMemoryKey]: normalizedFormKey,
  });
}
